import { Component, OnInit } from '@angular/core';
import { Payment, Transaction } from '../../models/index';
import { AuthService } from './../../services/auth.service';
import { PaymentMethodsService } from './../../services/payment-methods.service';
import { AlertService } from '../../services/alert.service';
import { TokenServiceService } from '../../services/token-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationsService } from '../../services/translations/translations.service';
import { MoneyPolicyService } from './../../services/money-policy.service';
import { IResponseObject } from 'src/app/models/response-object.model';
import { MoneyPolicy } from 'src/app/models/responseMoneySrcPolicy';
import { Subscription } from 'rxjs';
import { FLAGS_NAME, GENERAL_CONSTANTS, PCOL_TRANSACTION_KEYS } from '../../core/constants/General-constants';
import { ORDER_METHODS } from '../../core/constants/payMethods-cr';
import { PAYMENT_CATEGORIES } from 'src/app/constants/users.constants';
import { TranslateService } from '@ngx-translate/core';
import { GU_ORDER_METHODS } from 'src/app/core/constants/payMethods-gu';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { PuntosColombiaService } from 'src/app/services/puntos-colombia.service';
import { environment } from 'src/environments/environment';
import { IframeService } from 'src/app/services/iframe.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
// TODO: TECHNICAL DEBT 28125 https://dev.azure.com/payvalida/payValida/_workitems/edit/28125
export class HomeComponent implements OnInit {
  visualizeMethods: boolean;
  methodToVisualice: string;
  visualizeCC: boolean;
  visualizeNewCCFlow: boolean;
  visualizeDeposit: boolean;
  visualizeCash: boolean;
  visualizeWallet: boolean;
  visualizeReturn: boolean;
  visualizeTransaction: boolean;
  visualizeBnpl: boolean;
  visualizeUserForm = false;
  visualizeQrs: boolean;
  visualizeSubMenu: boolean;
  visualizeSubMenuGU: boolean;
  visualizePeruMethods = false;
  visualizeSplitMethods: boolean;
  visualizeSinpeMethods: boolean;
  visualizeCdcMethod = false;
  visualizePuntosColombia: boolean = false;
  visualizeApiPayIn: boolean = false;
  transaction: Transaction;
  info: Payment;
  paymentsSubMenu: Payment[];
  paymentsSubMenuGU: Payment[];
  listPaymentMethods: any[];
  orderID: string;
  loading = true;
  isCreditCardUnique = false;
  visualizeMoneyPolicy: boolean;
  policyData: IResponseObject<MoneyPolicy>;
  visibleReturnPayMethods = true;
  visibleReturnEmitter: Subscription;
  returnFromSubMenu = false;
  returnFromSubMenuGU = false;
  merchanDisabledtList = [];
  templates = GENERAL_CONSTANTS.TEMPLATES;
  infoOrderCheckout: any;
  merchantHasWallet: boolean = false;
  isCash: boolean = false;
  isDeposit: boolean = false;
  public activeLang = 'es';
  pcolHandlerRes: any = {};
  pColTransaction: any = {};
  isTcFormVisible: boolean = false;
  isApiPayInFormVisible: boolean = false;
  shouldKeepPreloadedTcForm: boolean = false;
  shouldKeepPreloadedApiPayInForm: boolean = false;

  //FLAGS
  flagSubMenu: boolean;
  flagUserForm: boolean;
  flagRedeban: boolean;
  deunaCheckoutFF: boolean = false;
  bnplCheckoutReturnFF: boolean = false;
  cdcCheckoutReturnFF: boolean = false;
  showAutoExposedTcForm: boolean = true;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly paymentMethodsService: PaymentMethodsService,
    private readonly alertService: AlertService,
    private readonly tokenServiceService: TokenServiceService,
    private readonly translationsService: TranslationsService,
    private readonly translate: TranslateService,
    private readonly moneyPolicyService: MoneyPolicyService,
    private featureFlagService: PayvalidaFeatureFlagService,
    private readonly ptosColService: PuntosColombiaService,
    private readonly activatedRoute: ActivatedRoute,
    private iframeService: IframeService
  ) {}

  async ngOnInit() {
    this.showAutoExposedTcForm = await this.iframeService.showAutoExposedTcForm();

    if (this.showAutoExposedTcForm) {
      this.isTcFormVisible = true;
      this.visualizeNewCCFlow = true;
      this.loading = false;

      return;
    }

    await this.launchDarkly();

    this.translate.setDefaultLang(this.activeLang);

    this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.DEUNA_CHECKOUT_FF, FLAGS_NAME.DEUNA_CHECKOUT_FF).subscribe((response: boolean) => {
      this.deunaCheckoutFF = response;
    });

    this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.CHECKOUT_RETURN_FF, FLAGS_NAME.CHECKOUT_RETURN_FF).subscribe((response: boolean) => {
      this.bnplCheckoutReturnFF = response;
    });

    this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.CDC_TRX_FAILED_CHECKOUT_RETURN_FF, FLAGS_NAME.CDC_TRX_FAILED_CHECKOUT_RETURN_FF).subscribe((response: boolean) => {
      this.cdcCheckoutReturnFF = response;
    });

    const token = this.tokenServiceService.getToken();

    this.activatedRoute.queryParams.subscribe(async (params) => {
      if (!params.hasOwnProperty(PCOL_TRANSACTION_KEYS.PCOCL_TRANSACION_ID_PARAM)) return;

      const pcoTransactionId = params[PCOL_TRANSACTION_KEYS.PCOCL_TRANSACION_ID_PARAM];

      try {
        this.pcolHandlerRes = await this.ptosColService.puntosColombiaHandler(pcoTransactionId, token);

        this.pColTransaction.isPcolTransaction = true;
        this.pColTransaction.reference = this.pcolHandlerRes.DATA.reference;
        this.pColTransaction.status = this.pcolHandlerRes.CODE;
        this.pColTransaction.remainingAmount = this.pcolHandlerRes.DATA.remainingAmount ?? GENERAL_CONSTANTS.NUMBER_ZERO;
        this.pColTransaction.pcolRedeemed = this.pcolHandlerRes.DATA.pointsAmount ?? GENERAL_CONSTANTS.NUMBER_ZERO;
        this.pColTransaction.totalAmount = this.pColTransaction.pcolRedeemed + this.pcolHandlerRes.DATA.remainingAmount;

        if (this.pColTransaction.remainingAmount === GENERAL_CONSTANTS.NUMBER_ZERO && !this.pcolHandlerRes.DATA.checkoutUrl) {
          const parentOrderData = this.tokenServiceService.getAndDecodeCustomToken(token);
          this.pColTransaction.pcolRedeemed = this.pColTransaction.pcolRedeemed > Number(parentOrderData.ORDER_AMOUT) ? Number(parentOrderData.ORDER_AMOUT) : this.pColTransaction.pcolRedeemed;
          this.pColTransaction.totalAmount = this.pColTransaction.pcolRedeemed;

          return await this.router.navigate(['checkout/alertTC'], { state: { pColData: this.pColTransaction } });
        }

        const checkoutUrl = this.pcolHandlerRes.DATA.checkoutUrl;
        const urlWithProtocol = checkoutUrl.startsWith('https') ? checkoutUrl : `${GENERAL_CONSTANTS.HTTPS_PROTOCOL}${checkoutUrl}`;
        const urlParams = new URLSearchParams(new URL(urlWithProtocol).search);
        const childOrderToken = urlParams.get('token');
        const childOrderData = this.tokenServiceService.getAndDecodeCustomToken(childOrderToken);
        this.pColTransaction.childReference = childOrderData.ORDER_REFERENCE;

        localStorage.setItem(`${PCOL_TRANSACTION_KEYS.PCOCL_TRANSACION_OBJECT_KEY}-${childOrderData.ORDER_REFERENCE}`, JSON.stringify(this.pColTransaction));

        return (window.location.href = `${environment.host}?token=${childOrderToken}`);
      } catch (_) {
        if (params.hasOwnProperty(PCOL_TRANSACTION_KEYS.PCOCL_TRANSACION_ID_PARAM)) {
          const searchParams = new URLSearchParams(window.location.search);

          searchParams.delete(PCOL_TRANSACTION_KEYS.PCOCL_TRANSACION_ID_PARAM);

          const newUrl = `${window.location.pathname}?${searchParams.toString()}${window.location.hash}`;
          window.location.href = newUrl;
        }

        this.loading = false;
      }
    });

    if (this.transaction != null) {
      if ('MULTILINK_CODE' in this.transaction) {
        this.loading = false;

        this.loadStyle(this.transaction.MERCHANT_TEMPLATE);

        this.visualizeUserForm = true;

        return;
      }

      this.loadStyle(this.transaction.MERCHANT_TEMPLATE);
    }

    this.disableBegin();
    this.disableComponent();

    if (!token) {
      this.loading = false;

      this.alertService.showAlertProblem(() => {
        this.router.navigate(['/error']);
      });
    } else {
      this.translationsService.setCurrentCountry();
      try {
        this.loading = true;

        const order = await this.paymentMethodsService.Order();

        this.orderID = order.OrderID;

        this.moneyPolicyService.getMoneySrcPolicy(token).subscribe(
          (data: IResponseObject<MoneyPolicy>) => {
            if (data.DATA.required) {
              this.policyData = data;
              this.visualizeMoneyPolicy = true;
            } else {
              this.enablePaymentMethods();
            }
          },
          () => {
            this.alertService.showAlertProblem(() => {
              this.router.navigate(['/error']);
            });
          }
        );

        this.loading = false;
      } catch (e) {
        this.loading = false;

        this.disableComponent();
        this.alertService.showAlertProblem(() => {
          this.router.navigate(['/error']);
        });
      }
    }
  }

  /**
   *
   * @description {validateMerchantAndData} Function to validate the trade of the transaction
   * @returns if you find the trade in the list
   */
  validateMerchantAndData() {
    const decodeToken = this.tokenServiceService.getAndDecodeToken() as Transaction;

    this.merchanDisabledtList = [
      { name: 'kuanto', code: 73 },
      { name: 'payvalida', code: 343 },
      { name: 'payvalida', code: 1304 }, //PROD
      { name: 'kuanto_ssterling', code: 31684 },
      { name: 'wenia', code: 32957 },
      { name: 'weniasas', code: 34127 }, //PROD
    ];

    return this.merchanDisabledtList.some((item) => item.code === decodeToken.MERCHANT_CODE);
  }

  funChangeCC(e: Payment) {
    this.info = e;
    this.disableComponent();
    this.visualizeCC = true;
  }

  changeToNewCcFlow(e: Payment) {
    this.info = e;
    this.disableComponent();
    this.isTcFormVisible = true;
    this.visualizeNewCCFlow = true;
  }

  funChangeCash(e: Payment) {
    this.info = e;

    this.disableComponent();

    this.visualizeCash = true;

    if (e.category === '3') {
      this.isCash = true;
      this.isDeposit = false;
    } else {
      this.isCash = false;
      this.isDeposit = false;
    }
  }

  funChangeDeposit(e: Payment) {
    this.info = e;

    this.disableComponent();

    this.visualizeDeposit = true;
  }

  funChangeTransfer(e: Payment) {
    this.info = e;

    this.disableComponent();

    this.methodToVisualice = e.template;
  }

  preloadEmbebedTcForm(event: boolean) {
    this.visualizeNewCCFlow = event;
    this.shouldKeepPreloadedTcForm = event;
    this.isTcFormVisible = false;
  }

  preloadEmbebedApiPayInForm(event: boolean) {
    this.visualizeApiPayIn = event;
    this.shouldKeepPreloadedApiPayInForm = event;
    this.isApiPayInFormVisible = false;
  }

  funChangeWallet(e: Payment) {
    this.info = e;

    this.disableComponent();

    this.visualizeWallet = true;
    this.methodToVisualice = e.template;
  }

  funChangeBnpl(e: Payment) {
    this.info = e;

    this.disableComponent();

    this.visualizeBnpl = true;
  }
  /**
   *
   * @description {funChangeSplitMethods} Function to activate the new payment method split payments
   * @param paymentInfo parent component payment information
   */
  funChangeSplitMethods(paymentInfo: Payment) {
    this.info = paymentInfo;

    this.disableComponent();

    this.visualizeSplitMethods = true;
  }
  /**
   *
   * @description {changeToSinpePayments} Function to activate the new sinpe methods
   * @param paymentInfo parent component payment information
   */
  changeToSinpePayments(paymentInfo: Payment) {
    if (!paymentInfo) {
      this.alertService.showAlertProblem();
      return;
    }

    this.info = paymentInfo;

    this.disableComponent();

    this.visualizeSinpeMethods = true;
  }

  /**
   *
   * @description {changeToPuntosColombia} Function to activate the new PuntosColombia methods
   * @param paymentInfo parent component payment information
   */
  changeToPuntosColombia(paymentInfo: Payment) {
    if (!paymentInfo) {
      this.alertService.showAlertProblem();

      return;
    }

    this.info = paymentInfo;

    this.disableComponent();

    this.visualizePuntosColombia = true;
  }

  /**
   *
   * @description {changeToApiPayIn} Function to activate the changeToApiPayIn method
   * @param paymentInfo parent component payment information
  */
  changeToApiPayIn(paymentInfo: Payment) {
    this.info = paymentInfo;
    this.disableComponent();
    this.isApiPayInFormVisible = true;
    this.visualizeApiPayIn = true;
  }

  /**
   *
   * @description {changeToCdcPayment} Function to activate the new sinpe methods
   * @param paymentInfo parent component payment information
   */
  changeToCdcPayment(paymentInfo: Payment) {
    this.info = paymentInfo;

    this.disableComponent();

    this.visualizeCdcMethod = true;
  }

  funChangeQrs(e: Payment) {
    this.info = e;

    this.disableComponent();

    this.visualizeQrs = true;
  }

  funSubMenu(e: Payment[]) {
    this.paymentsSubMenu = e;

    this.disableComponent();
    if (this.returnFromSubMenu) {
      this.visualizeMethods = true;
      this.returnFromSubMenu = false;
    } else {
      this.visualizeSubMenu = true;
    }
  }

  funSubMenuGU(e: Payment[]) {
    this.paymentsSubMenuGU = e;

    this.disableComponent();
    if (this.returnFromSubMenuGU) {
      this.visualizeMethods = true;
      this.returnFromSubMenuGU = false;
    } else {
      this.visualizeSubMenuGU = true;
    }
  }

  changeMethod() {
    this.disableComponent();
    this.isTcFormVisible = false;
    this.isApiPayInFormVisible = false;
    this.visualizeMethods = true;
    this.returnFromSubMenu = this.transaction.ORDER_METHOD == ORDER_METHODS.BNCR || this.transaction.ORDER_METHOD == ORDER_METHODS.BCR;
    this.returnFromSubMenuGU = this.transaction.ORDER_METHOD == GU_ORDER_METHODS.BAM || this.transaction.ORDER_METHOD == GU_ORDER_METHODS.BI;
  }

  enablePaymentMethods() {
    this.visualizeMoneyPolicy = false;

    this.enableBegin();
    this.getMethodsPayment();
  }
  /**
   *
   * @description {processPaymentMethod} Function to process the payment method and directly display its component
   * @param result
   * @returns
   */
  processPaymentMethod(result) {
    const paymentMethod = result.data;
    if (paymentMethod.category == '5' && this.paymentMethodsService.validatePeruCommercialnet(paymentMethod.code)) {
      this.funChangePeruMethods(paymentMethod);

      return;
    }

    this.loadTemplateMethod(paymentMethod);
  }
  /**
   * @description {loadTemplateMethod} Function to load payment method
   * @param paymentMethod payment method order
   */
  loadTemplateMethod = (paymentMethod: Payment) => {
    switch (paymentMethod.category) {
      case '1':
        this.funChangeCash(paymentMethod);
        break;
      case '2':
        this.funChangeTransfer(paymentMethod);
        break;
      case '3':
        this.funChangeCash(paymentMethod);
        break;
      case '4':
        this.isCreditCardUnique = true;
        break;
      case '5':
        this.funChangeCash(paymentMethod);
        break;
      case '6':
        this.funChangeWallet(paymentMethod);
        break;
      case '7':
        this.funChangeCash(paymentMethod);
        break;
      case '8':
        this.funChangeBnpl(paymentMethod);
        break;
      case PAYMENT_CATEGORIES.BANCOLOMBIA:
        this.changeToBnplMethods(paymentMethod);
        break;
      case '12':
        this.funChangeSplitMethods(paymentMethod);
        break;
      case '13':
        this.changeToSinpePayments(paymentMethod);
        break;
      case '15':
        this.changeToPuntosColombia(paymentMethod);
        break;
      case '16':
        this.changeToApiPayIn(paymentMethod);
        break;
      default:
        this.alertService.showAlertProblem();
        break;
    }
  };
  /**
   * @description {changeToBnplMethods} Function to validate and change between the payment options of bancolombia
   * @param paymentInfo
   */
  changeToBnplMethods(paymentInfo: Payment) {
    switch (paymentInfo.template) {
      case this.templates.CONSUMER_CREDIT:
        this.changeToCdcPayment(paymentInfo);
        break;
      case this.templates.QR:
        this.funChangeQrs(paymentInfo);
        break;
      case this.templates.CASH:
        this.funChangeCash(paymentInfo);
        break;
      case this.templates.BNPL_BANCOLOMBIA:
        this.funChangeBnpl(paymentInfo);
        break;
      default:
        this.alertService.showAlertProblem();
        break;
    }
  }

  private loadStyle(css: string) {
    const link = document.createElement('link');

    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `./assets/css/root/default.css?data=${new Date().getTime()}`;

    document.getElementsByTagName('HEAD')[0].appendChild(link);
  }

  funChangePeruMethods(paymentInfo: Payment) {
    this.info = paymentInfo;

    this.disableComponent();

    this.visualizePeruMethods = true;
  }

  disableComponent() {
    this.methodToVisualice = 'none';
    this.visualizeMethods = false;
    this.visualizeCC = false;
    this.visualizeDeposit = false;
    this.visualizeCash = false;
    this.visualizeReturn = false;
    this.visualizeWallet = false;
    this.visualizeMoneyPolicy = false;
    this.visualizeBnpl = false;
    this.visualizeQrs = false;
    this.visualizeSubMenu = false;
    this.visualizeSubMenuGU = false;
    this.visualizePeruMethods = false;
    this.visualizeSplitMethods = false;
    this.visualizeSinpeMethods = false;
    this.visualizeCdcMethod = false;
    this.visualizePuntosColombia = false;
    if (!this.shouldKeepPreloadedTcForm) this.visualizeNewCCFlow = false;
    if (!this.shouldKeepPreloadedApiPayInForm) this.visualizeApiPayIn = false;
  }

  private disableBegin() {
    this.visualizeTransaction = false;
    this.visualizeMethods = false;
  }

  private enableBegin() {
    this.visualizeTransaction = true;
    this.visualizeMethods = true;
  }

  /**
   * @description method that brings a specific payment method in Cash or Bank deposit
   */
  private async getMethodsPayment() {
    this.loading = true;

    let getValueEmitter = true;
    if (!this.visibleReturnEmitter) {
      await this.loadReturnPayMethods().then((res: boolean) => {
        getValueEmitter = res;
      });
    }

    if ('ORDER_METHOD' in this.transaction && this.transaction.ORDER_METHOD !== '') {
      this.visibleReturnPayMethods = getValueEmitter;

      if (this.transaction.ORDER_METHOD == ORDER_METHODS.BNCR || this.transaction.ORDER_METHOD == ORDER_METHODS.BCR || this.transaction.ORDER_METHOD == ORDER_METHODS.LAFISE) {
        this.loading = false;

        return;
      }

      if (this.transaction.ORDER_METHOD == GU_ORDER_METHODS.BAM || this.transaction.ORDER_METHOD == GU_ORDER_METHODS.BI) {
        this.loading = false;

        return;
      }

      if (this.transaction.ORDER_METHOD === ORDER_METHODS.BNPL && this.bnplCheckoutReturnFF) {
        const url = new URLSearchParams(window.location.search);
        const urlParamIsfaliedBnplTrx = Boolean(url.get(GENERAL_CONSTANTS.IS_PSE_FAILED_TRX_RETURNING_ID)) ?? false;
        const urlParamIsFailedBnplTrxRef = url.get(GENERAL_CONSTANTS.IS_PSE_FAILED_TRX_RETURNING_REFERENCE) ?? '';

        if (urlParamIsfaliedBnplTrx && urlParamIsFailedBnplTrxRef === this.transaction.ORDER_REFERENCE) {
          this.loading = false;

          return;
        }
      }

      if (this.transaction.ORDER_METHOD === ORDER_METHODS.CDC && this.cdcCheckoutReturnFF) {
        const url = new URLSearchParams(window.location.search);
        const urlParamIsfaliedCdcTrx = Boolean(url.get(GENERAL_CONSTANTS.IS_CDC_FAILED_TRX_RETURNING)) ?? false;
        const urlParamIsFailedCdcTrxId = url.get(GENERAL_CONSTANTS.IS_CDC_FAILED_TRX_RETURNING_REF) ?? '';

        if (urlParamIsfaliedCdcTrx && urlParamIsFailedCdcTrxId === this.transaction.ORDER_REFERENCE) {
          this.loading = false;

          return;
        }
      }

      try {
        const uniqueMethodResult = await this.paymentMethodsService.uniqueMethod();
        this.processPaymentMethod(uniqueMethodResult);

        this.loading = false;
      } catch (error) {
        this.alertService.showAlert(error, 'warning');
      }
      return;
    }

    this.loadPaymentMethods();
  }
  /**
   * @description {loadPaymentMethods} Function to load the payment methods of the order from home
   */
  loadPaymentMethods = () => {
    const token = this.tokenServiceService.getToken();

    this.paymentMethodsService.paymentMethods(token).subscribe(async (result: any) => {
      this.listPaymentMethods = result.DATA.paymentMethods;
      this.loading = false;
      if (this.listPaymentMethods.length === 1) {
        this.loadTemplateMethod(this.listPaymentMethods[0]);
      }
      return;
    });
  };
  /**
   * @description Promise to wait for response issued by payment-methods component
   */
  loadReturnPayMethods() {
    return new Promise((resolve, _) => {
      this.visibleReturnEmitter = this.paymentMethodsService.visibleReturnPayMethods.subscribe((result) => {
        resolve(result);
      });
    });
  }
  /**
   * @description {setInfoOrderPayments} function to build the object of the length of payment methods and order code
   * @param listPayments
   */
  setInfoOrderPayments(listPayments: Payment[]) {
    this.infoOrderCheckout = {
      paymentsLength: listPayments.length,
      orderID: this.orderID,
    };
  }

  /**
   * @description launchDarkly controls the flow of Feature Flags
   */
  async launchDarkly() {
    this.transaction = this.tokenServiceService.getAndDecodeToken();

    let merchant = this.transaction.MERCHANT_ID;
    if (!merchant) {
      merchant = this.transaction.MERCHANT_NAME;
    }

    //TODO https://dev.azure.com/payvalida/payValida/_workitems/edit/24798/
    await this.launchDarklySubMenu(merchant).then(async (responseSubMenu) => {
      this.flagSubMenu = responseSubMenu === true;

      //TODO https://dev.azure.com/payvalida/payValida/_workitems/edit/24800/
      await this.launchDarklyUserForm(merchant).then(async (responseUserForm) => {
        this.flagUserForm = responseUserForm === true;

        await this.launchDarklyRedeban(merchant).then((responseRedeban) => {
          this.flagRedeban = responseRedeban === true;
        });
      });
    });
  }

  /**
   * @description launchDarklySubMenu get FF value to submenu component
   */
  launchDarklySubMenu(merchant: string) {
    return new Promise((resolve) => {
      this.authService
        .loadLaunchDarkly(FLAGS_NAME.SUB_MENU_CR, merchant)
        .then((response: boolean) => resolve(response))
        .catch(() => {
          this.loading = false;

          this.disableComponent();

          this.alertService.showAlertProblem(() => this.router.navigate(['/error']));
        });
    });
  }

  /**
   * @description launchDarklySubMenu get FF value to submenu component
   * TODO https://dev.azure.com/payvalida/payValida/_workitems/edit/24800
   */
  launchDarklyUserForm(merchant: string) {
    return new Promise((resolve) => {
      this.authService
        .loadLaunchDarkly(FLAGS_NAME.UNIQUE_LINK, merchant)
        .then((response: any) => {
          resolve(response);
        })
        .catch(() => {
          this.loading = false;

          this.disableComponent();

          this.alertService.showAlertProblem(() => {
            this.router.navigate(['/error']);
          });
        });
    });
  }

  /**
   * @description launchDarklyWallet get FF value to redeban changes
   * TODO https://dev.azure.com/payvalida/payValida/_workitems/edit/24907
   */
  launchDarklyRedeban(merchant: string) {
    return new Promise((resolve) => {
      this.authService
        .loadLaunchDarkly(FLAGS_NAME.REDEBAN_CREDIT_CARDS, merchant)
        .then((response: any) => {
          resolve(response);
        })
        .catch(() => {
          this.loading = false;

          this.disableComponent();

          this.alertService.showAlertProblem(() => this.router.navigate(['/error']));
        });
    });
  }
}
